// 確認購物車中有無符合的商品，返回排序編號
const GetShopCartItemIndex = (state, { product, options }) => {
  // 確認商品是否存在購物車
  let index = -1;

  // 客製化商品不堆疊，直接返回-1
  if (product.IsCustom == "Y") {
    return index;
  }

  // 檢查目前購物車中是否有商品ID與選項都符合的項目
  state.shopcart.forEach((item, item_index) => {
    if (item.goodsID == product.GoodsID) {
      if (
        item.active_option[0] === options[0] &&
        item.active_option[1] === options[1]
      ) {
        index = item_index;
      }
    }
  });
  return index;
};

const GetCurrentStock = ({ product, options }) => {
  if (product.IsCustom == "Y") {
    let stock = product.CustomGoodsStock;
    let spec_list = [];
    options.forEach((option_id) => {
      const spec = product.CustomSpecList.find((item) => {
        return item.CustomSpecID == option_id;
      });

      spec_list.push({
        SpecTitle: spec.SpecTitle,
        SpecCategoryTitle: spec.SpecCategoryTitle,
      });
    });
    stock.SpecList = spec_list;
    return stock;
  } else {
    return product.Stock.find((item) => {
      return item.ColorID == options[0] && item.SizeID == options[1];
    });
  }
};

const GetCurrentImage = ({ product, options }) => {
  if (product.IsCustom == "Y") {
    return product.Image1;
  } else {
    const fullmatchImage = product.Picture.find((item) => {
      return item.ColorID == options[0] && item.SizeID == options[1];
    });
    const sizematchImage = product.Picture.find((item) => {
      return item.SizeID == options[1];
    });
    const colormatchImage = product.Picture.find((item) => {
      return item.ColorID == options[0];
    });

    if (fullmatchImage) {
      return fullmatchImage.Image;
    } else if (sizematchImage) {
      return sizematchImage.Image;
    } else if (colormatchImage) {
      return colormatchImage.Image;
    } else {
      return product.Image1;
    }
  }
};

// 檢查商品是否在販售期間

const shopcart_module = {
  namespaced: true,
  state: () => ({
    shopcart: [], //購物車
    product_data: null, //商品資料
    add_cart_message: 0, //購物車訊息顯示
  }),
  getters: {
    shop_cart_frozen_type(state) {
      let frozen_type = false;
      state.shopcart.forEach((item) => {
        if (item.is_frozen) {
          frozen_type = true;
        }
      });
      return frozen_type;
    },
  },
  actions: {},
  mutations: {
    // 檢查購物車中的商品格式
    CheckShopCartFormat(state) {
      state.shopcart.forEach((item) => {
        if (item.is_frozen == undefined || item.type == undefined) {
          console.log(item.is_frozen, item.type);
          // remove product
          state.shopcart.splice(state.shopcart.indexOf(item), 1);
        }
      });
    },
    // 檢查購物車加購商品數量
    CheckShopCartAddOnAmount(state) {
      let count = 0;
      state.shopcart.forEach((item) => {
        if (item.type == "add-on") {
          count += 1;
        }
      });
      if (count >= state.shopcart.length) {
        state.shopcart = [];
      }
    },
    // 非會員加入購物車
    AddShopCart(
      state,
      {
        product,
        options,
        amount,
        show_message = false,
        order_memo = "",
        shopcart_id = "",
        event_page = "",
      },
    ) {
      //檢查商品是否有設定限購數量，有的話則檢查目前購物車相同商品數量
      if (product.PurchaseLimit != 0) {
        let current_amount = 0;
        state.shopcart.forEach((item) => {
          if (item.goodsID == product.GoodsID) {
            current_amount += item.amount;
          }
        });
        if (current_amount + parseInt(amount) > product.PurchaseLimit) {
          alert(
            `此商品每人限購${product.PurchaseLimit}件，您目前已選購${current_amount}件`,
          );
          return;
        }
      }

      // 搜尋購物車中相同商品的位置，若無相同商品則返回-1
      const product_index = GetShopCartItemIndex(state, {
        product: product,
        options: options,
      });

      if (product_index == -1) {
        // 若商品不存在則新增
        const shopcart_item = {
          goodsID: product.GoodsID,
          stock: GetCurrentStock({ product: product, options: options }),
          image: GetCurrentImage({ product: product, options: options }),
          title: product.Title,
          option_name_1: product.Option1,
          option_name_2: product.Option2,
          active_option: options,
          is_custom: product.IsCustom,
          amount: parseInt(amount),
          shopcart_id: shopcart_id == "" ? [] : [shopcart_id],
          order_memo: order_memo,
          event_page: event_page,
          is_frozen: product.DeliveryFrozen == "Y" ? true : false,
          type: product.Type,
        };
        state.shopcart.push(shopcart_item);
      } else {
        // 若商品存在則增加數量
        state.shopcart[product_index].amount += parseInt(amount);
        // 若有shopcart_id則加入陣列中
        shopcart_id != ""
          ? state.shopcart[product_index].shopcart_id.push(shopcart_id)
          : "";
      }
      // 依情況顯示加入購物車訊息
      show_message ? (state.add_cart_message += 1) : "";
    },
    // 非會員移除購物車商品
    RemoveShopCart(state, { index, amount }) {
      if (amount == -1) {
        // 若數量為-1則直接將該商品移除
        state.shopcart.splice(index, 1);
      } else {
        // 若數量不為-1則扣除指定的數量
        state.shopcart[index].amount =
          parseInt(state.shopcart[index].amount) - parseInt(amount);
        // 若扣除數量後商品數量小於等於0，則移除該商品
        state.shopcart[index].amount <= 0
          ? state.shopcart.splice(index, 1)
          : "";
      }
    },
    // 設定購物車資料
    SetShopCart(state, shopcart) {
      state.shopcart = shopcart;
    },
    // 設定商品資料
    SetProductData(state, product_data) {
      if (state.product_data != null) {
        //合併已有資料
        state.product_data = state.product_data.concat(product_data);
        //去除重複資料
        state.product_data = Array.from(new Set(state.product_data));
      } else {
        state.product_data = product_data;
      }
    },
    // 設定購物車訊息顯示
    SetAddCartMessage(state, action) {
      const next_num = state.add_cart_message + action;
      next_num <= 0
        ? (state.add_cart_message = 0)
        : (state.add_cart_message = next_num);
    },
    // 檢查目前頁面ID與購物車中的商品是否符合
    CheckEventPageShopCart(state, event_page_id) {
      let all_match = true;
      state.shopcart.forEach((item) => {
        if (item.event_page != event_page_id) {
          all_match = false;
        }
      });

      if (!all_match) {
        state.shopcart = [];
      }
    },
  },
};

export { shopcart_module };
